export const Colors = {
  green: "#FFFFFF",
  house: "#FFFFFF",
};
